import config from '@juristat/config'

export const DRAFTING_URL = [
  config.usptoData.graphqlUrl.replace(/\/graphql.+/, ''),
  'classifier',
].join('/')
